import {AfterViewInit, Component, Inject, Input, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from "@angular/material/dialog";
import EventModel from "../../../model/event.model";
import {NgxMatDatetimepicker} from "@angular-material-components/datetime-picker";
import CalendarService from "../../../api/calendar/calendar.service";

@Component({
  selector: 'app-private-event',
  templateUrl: './private-event.component.html',
  styleUrls: ['./private-event.component.scss']
})
export class PrivateEventComponent implements OnInit, AfterViewInit{
  @Input() event: EventModel;
  public eventForm: FormGroup;

  @ViewChild(NgxMatDatetimepicker) picker: NgxMatDatetimepicker<any>;
  constructor(private calendarService: CalendarService, private fb: FormBuilder,
              public dialogRef: MatDialogRef<PrivateEventComponent>,
              private dialog: MatDialog,
              @Inject(MAT_DIALOG_DATA) public data: PrivateEventFormDialogModel) { }

  ngAfterViewInit(): void {
  }

  ngOnInit(): void {
    this.event = this.data.event;
    this.eventForm = this.fb.group({
      title: [this.event.title],
      description: [this.event.description],
      fromDate: [this.event.fromDate],
      toDate: [this.event.toDate],
    });
  }

  save() {
    const data = this.eventForm.getRawValue() as EventModel;

    if(this.event?.id) {
      data['id'] = this.event.id;
    }
    this.calendarService.createPrivateEvent(data).subscribe(result => {
      if(result) {
        this.dialogRef.close(result);
      }
    });

  }
}
export class PrivateEventFormDialogModel {
  constructor(public event: EventModel) {
  }
}

